import React, { useContext } from 'react';
import './Testimonial.scss';
import TestimoniCard from '../../components/TestimoniCard/TestimoniCard';
import Slider from "react-slick";
import { LanguageContext } from '../../context/LanguageContext';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

const Testimonial = () => {
    const { t } = useContext(LanguageContext);

    // slider
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    };

    return (
        <section className="testimonial-section" data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SectionTitle 
                            subTitle={t('testimonial.sectionTitle')}
                            title={t('testimonial.title')}
                        />
                    </div>
                    <div className="col-lg-6">
                        <p className="testimonial-title-text">{t('testimonial.description')}</p>
                    </div>
                </div>

                <Slider {...settings} className="testimoni-slider">
                    {
                        t('testimonial.comments').map((comment, index) => (
                            <TestimoniCard 
                                key={index}
                                testimonial={{
                                    img: comment.image,
                                    name: comment.name,
                                    description: comment.comment,
                                    rating: comment.rating
                                }}
                            />
                        ))
                    }
                </Slider>
               
            </div>
        </section>
    );
};

export default Testimonial;